/**
 * ArticleH4 Functional Component
 * @Package - seo
 * @Author - SEO
 * @description: ArticleH4 for SEO pages used inside Article Component
 */

/**
 * ArticleH4 Component for SEO pages
 */

import React, { useCallback } from 'react'
import styled from 'styled-components'
import { Text, Anchor } from '@usap/uicomponents'

const H4EXP = /<h4>(?<text>.*?)<\/h4>/
const StyledAnchor = styled(Anchor)`
  margin-top: 8px;
  margin-left: 24px;

  @media (min-width: 1009px) {
    margin-top: 16px;
  }
`

export default function ArticleSubMenu({ menuIndex, data, getHandleClick }) {
  const h4Arr = data.split(H4EXP)
  const getInnerHTML = useCallback(value => ({ __html: value }), [])

  return h4Arr.map((value, index) => {
    const oddIndex = index % 2 === 1
    const mapKey = `articleH4-${value.length > 10 ? value.substring(0, 10) : value}`
    const parentRefArticlId = `article-id-${menuIndex}-`

    return oddIndex ? (
      <StyledAnchor
        id={`article-menu-${menuIndex}-sub-${index}`}
        tabIndex="0"
        key={mapKey}
        size="small"
        a11yTitle={`Article - ${value}`}
        label={(
          <Text
            size="small"
            weight="normal"
            color="blueLink"
            dangerouslySetInnerHTML={getInnerHTML(value)}
          />
        )}
        onClick={getHandleClick(parentRefArticlId + index)}
      />
    )
      : ''
  })
}
